import React from 'react';
import { FadeIn } from './ui';
import { HelpCircle, CheckCircle2 } from 'lucide-react';
const faqs = [{
  q: '¿No tengo tiempo para esto?',
  a: 'Los protocolos duran 5 minutos. Los puedes hacer mientras manejas al trabajo o en tu break.'
}, {
  q: '¿Tengo que dejar de comer mi comida latina?',
  a: 'No. Te enseñamos a optimizar tu comida, no a dejarla. Sigue con tus frijoles, solo cambia el timing.'
}, {
  q: '¿Es seguro? No quiero tomar cosas extrañas.',
  a: 'No vendemos pastillas. Usamos luz, respiración y hábitos naturales. Es salud pura.'
}];
export function FAQ() {
  return <section className="py-24 px-4 bg-brand-darker" data-id="element-11">
      <div className="max-w-3xl mx-auto" data-id="element-12">
        <FadeIn data-id="element-13">
          <div className="text-center mb-16" data-id="element-14">
            <h2 className="font-bebas text-4xl md:text-5xl text-white mb-4" data-id="element-15">
              Preguntas Frecuentes
            </h2>
            <p className="text-zinc-400" data-id="element-16">
              Resolvemos tus dudas antes de empezar.
            </p>
          </div>
        </FadeIn>

        <div className="space-y-6" data-id="element-17">
          {faqs.map((faq, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-18">
              <div className="bg-brand-card border border-white/5 rounded-2xl p-6 md:p-8" data-id="element-19">
                <div className="flex gap-4 items-start mb-4" data-id="element-20">
                  <HelpCircle className="w-6 h-6 text-brand-orange shrink-0 mt-1" data-id="element-21" />
                  <h3 className="text-xl font-bold text-white" data-id="element-22">{faq.q}</h3>
                </div>
                <div className="flex gap-4 items-start pl-10" data-id="element-23">
                  <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-24" />
                  <p className="text-zinc-300 leading-relaxed" data-id="element-25">{faq.a}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}